import { getQueryParams, getURLByModelType, normalize } from 'api/models';
import axios from 'axios';
import { API_VERSION, ROOT_URL } from 'constants/index';
import { GeneralIds, ModelTypes, QueryParams, ResponseMeta } from 'types/types';

interface Params {
  type: ModelTypes;
  ids?: GeneralIds;
  queryParams?: QueryParams;
  signal?: AbortSignal; // Use AbortSignal for better type safety
}

export async function query<T>({
  type,
  ids,
  queryParams,
  signal,
}: Params): Promise<{ data: T; meta: ResponseMeta }> {
  const path = getURLByModelType(type, ids);
  const params = getQueryParams(queryParams);

  const { data } = await axios({
    url: `${ROOT_URL}/${API_VERSION}/${path}${params}`,
    method: 'GET',
    signal,
  });

  return {
    data: normalize(data),
    meta: data.meta,
  };
}
